const STORAGE_KEY = "dap_session";
const MAX_AGE_MS = 4 * 60 * 60 * 1000;
const listeners = new Set();
let memorySession = null;

function getSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return memorySession;
  }
}

function setSession(data) {
  memorySession = data;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* storage blocked — in-memory fallback is already set */
  }
  notify(data);
}

function clearSession() {
  memorySession = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage blocked — in-memory fallback is already cleared */
  }
  notify(null);
}

function parseCutoffMinutes(cutoff) {
  if (typeof cutoff !== "string" || cutoff.length === 0) return null;
  const match = /^(\d{1,2}):(\d{2})$/.exec(cutoff.trim());
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
  return hours * 60 + minutes;
}

function isSessionValid() {
  const session = getSession();
  if (!session || typeof session !== "object") return false;

  const date = session.date;
  if (!date || typeof date !== "string") return false;

  const resolvedAt = session.resolved_at;
  if (typeof resolvedAt !== "number" || !Number.isFinite(resolvedAt))
    return false;

  const now = new Date();
  const todayLocal = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  if (date < todayLocal) return false;

  if (Date.now() - resolvedAt > MAX_AGE_MS) return false;

  const nowMinutes = now.getHours() * 60 + now.getMinutes();

  if (session.handling_date === todayLocal) {
    const handlingCutoffMinutes = parseCutoffMinutes(session.handling_cutoff);
    if (handlingCutoffMinutes !== null) {
      if (nowMinutes >= handlingCutoffMinutes) return false;
    } else if (session.sameday_delivery === false) {
      const sameDayCutoffMinutes = parseCutoffMinutes(session.same_day_cutoff);
      if (sameDayCutoffMinutes !== null && nowMinutes >= sameDayCutoffMinutes) {
        return false;
      }
    }
  }

  return true;
}

function onSessionChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function notify(session) {
  for (const fn of listeners) {
    try {
      fn(session);
    } catch {
      /* listener errors must not break session management */
    }
  }
  window.dispatchEvent(
    new CustomEvent("dap:session-change", { detail: { session } }),
  );
}

window.DAP = {
  getSession,
  setSession,
  clearSession,
  isSessionValid,
  onSessionChange,
};

{
  const s = getSession();
  if (s && isSessionValid()) {
    notify(s);
  } else if (s) {
    clearSession();
  }
}
